/**
 *  Colors
 */

const Red = "#e20014";
const Black = "rgba(34, 45, 50, 1)";
const Black25 = "rgba(34, 45, 50, .25)";
const Black50 = "rgba(34, 45, 50, .50)";

const Gray = "gray";

const Danger = "#f76564";
const Warning = "rgba(250, 182, 0, 1)";
const Success = "#26ab6d";
const Info = "#52ddfc";

const White = "#FFFFFF";
const Disabled = "#e2001452";

export const colors = {
  Primary: Red,
  Secondary: Black,
  Gray,
  White,
  Black,
  Black25,
  Black50,
  Danger,
  Warning,
  Success,
  Info,
  Disabled,
};
